/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ImportacaoEquipamentosAutorizacaoFormDto } from '../models/importacao-equipamentos-autorizacao-form-dto';
import { ImportacaoEquipamentosCriteriaDto } from '../models/importacao-equipamentos-criteria-dto';
import { ImportacaoEquipamentosDto } from '../models/importacao-equipamentos-dto';
import { ImportacaoEquipamentosFormDto } from '../models/importacao-equipamentos-form-dto';
import { ImportacaoEquipamentosPageDto } from '../models/importacao-equipamentos-page-dto';


/**
 * Importação de Equipamentos Geradores Radiação
 */
@Injectable({
  providedIn: 'root',
})
export class ImportacaoEquipamentosGeradoresRadiacaoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPedidosImpEquipamentos
   */
  static readonly GetPedidosImpEquipamentosPath = '/importacao-equipamentos-geradores-radiacao';

  /**
   * Pesquisar Importacoes Equipamentos Geradores Radia.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidosImpEquipamentos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidosImpEquipamentos$Response(params?: {
    criteria?: ImportacaoEquipamentosCriteriaDto;
  }): Observable<StrictHttpResponse<ImportacaoEquipamentosPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoEquipamentosGeradoresRadiacaoService.GetPedidosImpEquipamentosPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoEquipamentosPageDto>;
      })
    );
  }

  /**
   * Pesquisar Importacoes Equipamentos Geradores Radia.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidosImpEquipamentos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidosImpEquipamentos(params?: {
    criteria?: ImportacaoEquipamentosCriteriaDto;
  }): Observable<ImportacaoEquipamentosPageDto> {

    return this.getPedidosImpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoEquipamentosPageDto>) => r.body as ImportacaoEquipamentosPageDto)
    );
  }

  /**
   * Path part for operation submeterImpEquipamentos
   */
  static readonly SubmeterImpEquipamentosPath = '/importacao-equipamentos-geradores-radiacao';

  /**
   * Submeter Importação Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterImpEquipamentos()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterImpEquipamentos$Response(params?: {
    body?: {
'impEGRForm'?: ImportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<StrictHttpResponse<ImportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoEquipamentosGeradoresRadiacaoService.SubmeterImpEquipamentosPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Submeter Importação Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterImpEquipamentos$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterImpEquipamentos(params?: {
    body?: {
'impEGRForm'?: ImportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<ImportacaoEquipamentosDto> {

    return this.submeterImpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoEquipamentosDto>) => r.body as ImportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation getPedidoImpEquipamentos
   */
  static readonly GetPedidoImpEquipamentosPath = '/importacao-equipamentos-geradores-radiacao/{id}';

  /**
   * Pesquisar Importacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidoImpEquipamentos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoImpEquipamentos$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ImportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoEquipamentosGeradoresRadiacaoService.GetPedidoImpEquipamentosPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Pesquisar Importacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidoImpEquipamentos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoImpEquipamentos(params: {
    id: number;
  }): Observable<ImportacaoEquipamentosDto> {

    return this.getPedidoImpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoEquipamentosDto>) => r.body as ImportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation updateImpEquipamentos
   */
  static readonly UpdateImpEquipamentosPath = '/importacao-equipamentos-geradores-radiacao/{id}';

  /**
   * Editar Importacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImpEquipamentos()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateImpEquipamentos$Response(params: {
    id: number;
    body?: {
'impEGRForm'?: ImportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<StrictHttpResponse<ImportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoEquipamentosGeradoresRadiacaoService.UpdateImpEquipamentosPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Editar Importacao Equipamentos Geradores Radiacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateImpEquipamentos$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateImpEquipamentos(params: {
    id: number;
    body?: {
'impEGRForm'?: ImportacaoEquipamentosFormDto;
'faturaProformaEquiv'?: Blob;
}
  }): Observable<ImportacaoEquipamentosDto> {

    return this.updateImpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoEquipamentosDto>) => r.body as ImportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoImpEquipamentos
   */
  static readonly UpdateAutorizacaoImpEquipamentosPath = '/importacao-equipamentos-geradores-radiacao/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido importação de equipamentos GR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoImpEquipamentos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoImpEquipamentos$Response(params: {
    id: number;
    body?: ImportacaoEquipamentosAutorizacaoFormDto
  }): Observable<StrictHttpResponse<ImportacaoEquipamentosDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoEquipamentosGeradoresRadiacaoService.UpdateAutorizacaoImpEquipamentosPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoEquipamentosDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido importação de equipamentos GR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoImpEquipamentos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoImpEquipamentos(params: {
    id: number;
    body?: ImportacaoEquipamentosAutorizacaoFormDto
  }): Observable<ImportacaoEquipamentosDto> {

    return this.updateAutorizacaoImpEquipamentos$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoEquipamentosDto>) => r.body as ImportacaoEquipamentosDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoImportacaoEgr
   */
  static readonly PreviewDocAutorizacaoImportacaoEgrPath = '/importacao-equipamentos-geradores-radiacao/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoImportacaoEgr()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoImportacaoEgr$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoEquipamentosGeradoresRadiacaoService.PreviewDocAutorizacaoImportacaoEgrPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoImportacaoEgr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoImportacaoEgr(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoImportacaoEgr$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
